import React from "react"
import { useState } from "react";

import "./Hero.css"

const pegarSessionStorage = () => {
  try {
    const raw = sessionStorage.getItem("user");
    if (!raw) return null;
    const data = JSON.parse(raw);
    return typeof data === "object" && data ? data : null;
  } catch {
    return null;
  }
};

export default function Hero(){
    const [session] = useState(() => pegarSessionStorage());
    const name = session?.name ?? "Visitante";

    return(
        <div className="hero-main">
            <h1 className="hero-title"> Seja Bem-Vindo, {name}!</h1>
            <p className="hero-desciption"> Verifique as licenças, Acesse servidor dos SAP e Gerencie Usuários e Dispositivos.</p>
        </div>
    )
}